import React, { useEffect } from "react";
import { Box, Grid } from "@material-ui/core";
import { useSelector } from "react-redux";
import HeaderContainer from "./Header/HeaderContainer";
import SimpleSnackbar from "components/common/SnackBar";
import LoadingView from "./LoadingView";
import SideBar from "./Header/Sidebar";
import appActions from "./actions";
import PropTypes from "prop-types";
import useStyles from "./Styles";
import settingsActions from "components/settings/actions";
import InviteUserDialog from "components/User/CreateUser/InviteUserDialog";
import featureSettingsActions from "components/FeatureSettings/actions";
// import useGetViewPortDimensions from "hooks/useGetViewPortDimensions";

export const checkProtected = (isProtected, loggedIn, role, checkRoles) => {
  const logincheck = isProtected ? loggedIn : true;
  const roleCheck = checkRoles.length > 0 ? checkRoles.includes(role) : true;
  return logincheck && roleCheck;
};

const App = ({
  children,
  isProtected = false,
  checkRoles = [],
  showHeader = true,
  showSidebar = false,
  adminHeader = false,
}) => {
  const { busy, toast } = useSelector((state) => state.app);
  const { loggedIn, role } = useSelector((state) => state.auth);

  const { message, type } = toast;
  const classes = useStyles();
  const { removeToastMessage } = appActions();
  const { aboutMe } = settingsActions();    // currently not used
  const { getFeatureSettings } = featureSettingsActions();

  useEffect(() => {   // currently not used
    if (loggedIn) {
      aboutMe();
      getFeatureSettings()
    }
    

  }, [aboutMe, loggedIn]);

  return (
    <div className={classes.root}>
      <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no" />
      {showHeader && <HeaderContainer adminHeader={adminHeader} />}
      {showHeader && loggedIn && showSidebar && <SideBar />}

      {checkProtected(isProtected, loggedIn, role, checkRoles) && (
        <Grid className={classes.pageContent}>
          {showHeader ? (
            adminHeader ? (
              <>
                <div
                  className={classes.fakeToolbar}
                />
                <Box height="1px">
                  <LoadingView currentlySending={busy} />
                </Box>

                <Box height={"6vh"} />
              </>
            ) : (
              <>
                <div
                  className={classes.fakeToolbar}
                />
                <Box height="1px">
                  <LoadingView currentlySending={busy} />
                </Box>
              </>
            )
          ) : (
            <></>
          )}
          {children}
        </Grid>
      )}

      {message && (
        <SimpleSnackbar
          clearMessage={removeToastMessage}
          message={message}
          type={type}
        />
      )}
      <InviteUserDialog />
    </div>
  );
};

App.propTypes = {
  checkRoles: PropTypes.arrayOf(PropTypes.string.isRequired),
  children: PropTypes.node.isRequired,
  isProtected: PropTypes.bool,
  showHeader: PropTypes.bool,
};

App.defaultProps = {
  checkRoles: [],
  isProtected: false,
  showHeader: true,
};

export default App;
